import { Fetcher } from '@this/src/util';

type CalendarConnectionResponse = Record<'google_calendar_connected', boolean>;

export type CalendarConnection = {
  googleCalendarConnected: boolean;
};

export const fetchCalendarConnection = async (): Promise<CalendarConnection> => {
  const response = await Fetcher.get<CalendarConnectionResponse>('/trips/ai_messages/calendar_connection');

  return {
    googleCalendarConnected: response.google_calendar_connected
  };
};
